import { render, staticRenderFns } from "./regVip.vue?vue&type=template&id=36f67729&scoped=true"
import script from "./regVip.vue?vue&type=script&lang=js"
export * from "./regVip.vue?vue&type=script&lang=js"
import style0 from "./regVip.vue?vue&type=style&index=0&id=36f67729&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f67729",
  null
  
)

export default component.exports